import spiderman from '@/spiderman/index';

const { axios, api } = spiderman;

async function sendToS3(member, formData) {
  return (
    await axios.post(api.chatPictures,
      formData,
      {
        headers: {
          jwt: member.jwt,
        },
      })
  ).data;
}

export default {
  sendToS3,
};
